module.exports = __webpack_public_path__ + "img/_DSC0804.eae6c813.jpg";